import React, { useState, useEffect } from 'react'
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import Facebook from '../components/Facebook';
import Google from '../Google';
import {loginCheckEmail} from '../config/Variables';
import Header from '../partials/Header';
function CheckEmail() {
 
  //const Login=() =>{
  const [email, setEmail] = useState("");
  const [messagelog, setMessagelog] = useState("");
  let location = useLocation();
  //const [password, setPassword] = useState();
  //const device_name = 'nokia';

  // const history = useNavigate();
  const navigate = useNavigate();
//console.log(navigate.userAgent);
//console.log(window.navigator.userAgent);
var element = document.getElementById("header-react");
if(element){
element.classList.add("hide");
}

  useEffect(() => {
    if (localStorage.getItem('user-info')) {
      // history("/add");
      //  navigate('/sample');
      return <Navigate to="/personalize" />
      document.title = `Journey`;
    }

  }, []);
  if (localStorage.getItem('user-info')) {
    return <Navigate to="/personalize" />
  }
  const handleCheckChange =(evnt)=>{
    if(evnt==='successsfirstfacebook'){
      navigate('/personalize');
    }
      if(evnt==='successssecondfacebook'){
        var domainurl=  window.location.origin;
        window.location.href = domainurl;
      }

    }

    const handleKeyPress =(evnt)=>{
      if(evnt.key === 'Enter'){
        login();
      }
  
      }
  async function login() {
    
    if(email==""){
      setMessagelog('يجب ادخال بريدك الالكتروني قبل التسجيل');
    }else{
      const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if(!email || regex.test(email) === false){
              setMessagelog("البريد الإلكتروني غير صحيح"); 
            return false;
        }


    let item = { email };
    let result = await fetch(loginCheckEmail, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": 'application/json'
      },
      body: JSON.stringify(item)
    });

    result = await result.json();
    if (result.message.code == '200') {
      navigate('/login/'+email);
    }
    else {
      navigate('/registersimple/'+email);
    }
  }
  // return <Navigate to="/register" state={{ from: location }} replace />;
    //   localStorage.setItem("user-info", JSON.stringify(result));
    //history('/add');
    //JSON.parse(
  } if (localStorage.getItem('user-info')) {
    return (
      <div>
        You Are Login
      </div>
    );
  } else {
    return (
      <>
      <Header />
      <main>
      
      <div className="grid-x align-center">
      <div className="cell shrink">
      <div className="form-area-wrap padding-vertical-3">
                                <div className="section-title">
            <h3>انشئ حساباً خاصاً بك​</h3>
            <p>سجل وابق مطلعاً على آخر الأخبار  ​</p>
          </div>
          <div className="form-area">


          <div className="message alert text-center">
            {messagelog}
          </div>

            <div className="input-field">

              <span className="ico-label"><i className="icomoon-icon icon-envelop2"></i></span>
              <input type="email" required="required" name="email" onKeyDown={handleKeyPress} placeholder="البريد الالكتروني" onChange={(e) => setEmail(e.target.value)} />
            </div>


            <div className="text-center">
              <button onClick={login} className="button submit-btn" onKeyPress={login}  >تسجيل</button>
              <div className="custom-txt-style"><span>أو</span></div>
              <div className="form-socials-btns">

               
                <Facebook samirCallback = {handleCheckChange} />
                <Google  />

              </div>

            </div>
          </div>
        </div>


      </div>
      </div>
      </main>
      </>
    );
  }


  
}

export default CheckEmail;
